/**
 * @generated SignedSource<<4c03715cb3db6f0c997206f6e8596539>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type JoinCommunitySendVerificationEmailInput = {
  email: string;
  firstName: string;
  lastName: string;
  organizationId: string;
  timezone: string;
};
export type useJoinCommunitySendVerificationEmailMutation$variables = {
  input: JoinCommunitySendVerificationEmailInput;
};
export type useJoinCommunitySendVerificationEmailMutation$data = {
  readonly joinCommunitySendVerificationEmail: {
    readonly data: boolean | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type useJoinCommunitySendVerificationEmailMutation = {
  response: useJoinCommunitySendVerificationEmailMutation$data;
  variables: useJoinCommunitySendVerificationEmailMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "JoinCommunitySendVerificationResponse",
    "kind": "LinkedField",
    "name": "joinCommunitySendVerificationEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useJoinCommunitySendVerificationEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useJoinCommunitySendVerificationEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "85f80be35ab5c2540b5f44df329640ed",
    "id": null,
    "metadata": {},
    "name": "useJoinCommunitySendVerificationEmailMutation",
    "operationKind": "mutation",
    "text": "mutation useJoinCommunitySendVerificationEmailMutation(\n  $input: JoinCommunitySendVerificationEmailInput!\n) {\n  joinCommunitySendVerificationEmail(input: $input) {\n    data\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a0c2f6b9fc44cd11ba414fb017abd5c";

export default node;
